// import react libraries
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
// import common components
import SideBar from "./SideBar";
import Swal from "sweetalert2";
import { AuthContext } from "../context";

const Layout = ({children, sendTabCheckDataFromChild}) => {
    // get last toggle status
    const { t } = useTranslation();
    const authContext = useContext(AuthContext);
    const local = localStorage.getItem('toggle');
    const locale = localStorage.getItem('locale');
    // variable
    const [isToggle, setIsToggle] = useState(parseInt(local) ? parseInt(local) : 0);

    const handleToggleFromChild = (data) => {
        setIsToggle(data);
    };
    const handleTabChangeDataFromChild = (data) => {
        if(data.tab === 'logout') {
            Swal.fire({
                title: `${ t("are you sure you want to exit")}?`,
                text: `${ t("if you proceed, you will be signed out")}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t('yes')}`,
                cancelButtonText: `${ t('no')}`
            }).then((result) => {
                if (result.isConfirmed) {
                    if(data.link === '/logout') {
                        authContext.logout();
                    }
                }
            });
        } else {
            sendTabCheckDataFromChild(data);
        }
    };

    return (
        <div className="relative">
            <div className="" >
                <SideBar setToggleFromChild={handleToggleFromChild} sendTabChangeDataFromChild={handleTabChangeDataFromChild} />
            </div>
            <div className={(isToggle ? 'sm:ml-16' : (locale === 'gr' ? 'md:ml-60' : 'md:ml-56')) + " bg-background-normal1 h-full min-h-screen"}>
                <div className={(isToggle ? "mt-20" : "") + " sm:mt-0 p-2 sm:p-4 space-y-2 sm:space-y-4"}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Layout;